import type { Option } from '@/types/option'
import { httpClient } from '../../httpClient'

export type IdeaUser = Option & {
  avatar?: string
  area?: string
}

type ListAvailableIdeaUsers = {
  ideaUsers: IdeaUser[]
}

type ListAvailableIdeaUsersResponse = {
  ideaUsers: {
    id: string
    name: string
    image: string
    area: string
  }[]
}

// todo: fazer testes
export async function listAvailableIdeaUsers(
  name: string,
): Promise<ListAvailableIdeaUsers> {
  const { data } = await httpClient.get<ListAvailableIdeaUsersResponse>(
    'ideas/idea-users/users-available',
    {
      params: {
        search: name,
      },
    },
  )

  return {
    ideaUsers:
      data.ideaUsers.map((ideaUser) => ({
        value: ideaUser.id,
        label: ideaUser.name,
        avatar: ideaUser.image,
        area: ideaUser.area,
      })) ?? [],
  }
}
